import { FC } from 'react'

export interface OtherPartnerMatch {
  id: string
  name: string
  code: string
}

export interface EmailAlertsSummaryBarProps {
  selectedPartnerLabel: string
  visibleCardCount: number
  totalCardCount: number
  totalRecipientCount: number
  /** (partner, service) pairs the code sends for which nobody receives — BDL20-4262. */
  notConfiguredCount?: number
  searchTerm: string
  otherPartnersMatching: OtherPartnerMatch[]
  onJumpToPartner: (partner: OtherPartnerMatch) => void
}

export const EmailAlertsSummaryBar: FC<EmailAlertsSummaryBarProps> = ({
  selectedPartnerLabel,
  visibleCardCount,
  totalCardCount,
  totalRecipientCount,
  notConfiguredCount,
  searchTerm,
  otherPartnersMatching,
  onJumpToPartner,
}: EmailAlertsSummaryBarProps) => {
  return (
    <div className='flex flex-col gap-2 mt-4'>
      <div className='text-[13px] text-N-500'>
        Showing <b className='text-N-800'>{selectedPartnerLabel}</b> ·{' '}
        {visibleCardCount} of {totalCardCount} reports shown ·{' '}
        {totalRecipientCount} recipient{totalRecipientCount === 1 ? '' : 's'}{' '}
        configured
        {notConfiguredCount !== undefined && notConfiguredCount > 0 && (
          <>
            {' '}
            ·{' '}
            <span className='text-P-800 font-semibold'>
              {notConfiguredCount} not configured
            </span>
          </>
        )}
      </div>
      {searchTerm && (
        <div className='text-[13px] text-P-800 bg-P-50 border border-P-200 rounded-md px-3 py-2 flex items-center gap-2 flex-wrap'>
          <span>
            {totalCardCount === 0
              ? `No reports match "${searchTerm}" under ${selectedPartnerLabel}`
              : `Filtered by "${searchTerm}"`}
          </span>
          {otherPartnersMatching.length > 0 && (
            <>
              <span className='font-semibold text-P-900'>
                Other partners matching:
              </span>
              {otherPartnersMatching.map((partner) => (
                <button
                  key={partner.id}
                  type='button'
                  onClick={() => onJumpToPartner(partner)}
                  className='border border-P-300 bg-white text-P-900 rounded-full px-3 py-1 text-[12.5px] font-semibold hover:bg-P-100'>
                  {partner.name}
                </button>
              ))}
            </>
          )}
        </div>
      )}
    </div>
  )
}

export default EmailAlertsSummaryBar
